import { createFileRoute } from "@tanstack/react-router";
import AssetsDashboardPage from "src/components/app/AssetsDashboardPage/AssetsDashboardPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getPortalDashboardData } from "src/server/functions/Portal";

// The assets dashboard. Filters, grouping and the view mode live in the `CL_assetDashboardState`
// cookie (not the URL), so the server renders the first page of assets with them.
export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/")({
  loader: projectLoader((projectId) => getPortalDashboardData({ data: projectId })),
  component: PortalDashboard,
});

function PortalDashboard() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <AssetsDashboardPage {...data} />}
    </DeferredLoaderData>
  );
}
